module.exports = __webpack_public_path__ + "static/media/2.9b33c85f.JPG";